<template>
  <div>
    <el-form :model="detailForm" :rules="rules" ref="detailForm" label-width="100px" class="demo-detailForm">
      <el-form-item label="版本" prop="version">
        <span>{{version}}</span>
      </el-form-item>
      <el-form-item label="所属大类">
        <el-select :disabled="statusView!='C'?false:true" style="width:100%;" v-model="detailForm.parentId" placeholder="请选择所属大类">
          <el-option v-for="v,i in parentList" :label="v.name" :value="v.code" :key="i"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="评分项名称" prop="name">
        <el-input :disabled="statusView!='C'?false:true" v-model="detailForm.name"></el-input>
      </el-form-item>
      <el-form-item label="SPM" prop="version">
        <el-input :disabled="statusView!='C'?false:true" v-model="detailForm.version"></el-input>
      </el-form-item>
      <el-form-item label="Wt.1" prop="wt1">
        <el-input :disabled="statusView!='C'?false:true" v-model="detailForm.wt1" @input="detailForm.wt1=detailForm.wt1.replace(/[^\d.]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="Wt.2">
        <el-input :disabled="statusView!='C'?false:true" v-model="detailForm.wt2" @input="detailForm.wt2=detailForm.wt2.replace(/[^\d.]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="最大分值" prop="maxValue">
        <el-input :disabled="statusView!='C'?false:true" v-model="detailForm.maxValue" @input="detailForm.maxValue=detailForm.maxValue.replace(/[^\d.]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="Description" prop="description">
        <el-input :disabled="statusView!='C'?false:true" type="textarea" :rows="2" placeholder="请输入内容" v-model="detailForm.description">
        </el-input>
      </el-form-item>
      <el-form-item label="评分标准说明1" prop="standard1">
        <el-input :disabled="statusView!='C'?false:true" type="textarea" :rows="2" placeholder="请输入内容" v-model="detailForm.standard1">
        </el-input>
      </el-form-item>
      <el-form-item label="评分标准说明2" prop="standard2">
        <el-input :disabled="statusView!='C'?false:true" type="textarea" :rows="2" placeholder="请输入内容" v-model="detailForm.standard2">
        </el-input>
      </el-form-item>
      <el-form-item label="评分标准说明3" prop="standard3">
        <el-input :disabled="statusView!='C'?false:true" type="textarea" :rows="2" placeholder="请输入内容" v-model="detailForm.standard3">
        </el-input>
      </el-form-item>
      <el-form-item label="评分标准说明4" prop="standard4">
        <el-input :disabled="statusView!='C'?false:true" type="textarea" :rows="2" placeholder="请输入内容" v-model="detailForm.standard4">
        </el-input>
      </el-form-item>
      <el-form-item label="评分标准说明5" prop="standard5">
        <el-input :disabled="statusView!='C'?false:true" type="textarea" :rows="2" placeholder="请输入内容" v-model="detailForm.standard5">
        </el-input>
      </el-form-item>
      <el-form-item label="排序" prop="orderNo">
        <el-input :disabled="statusView!='C'?false:true" v-model="detailForm.orderNo" @input="detailForm.orderNo=detailForm.orderNo.replace(/[^\d.]/g,'')"></el-input>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="center" v-if="statusView!='C'">
      <el-button type="primary" size="small" @click="onSave('detailForm')">保存</el-button>
    </el-row>
  </div>
</template>
<script>
import apiService from "@/api/AAA/index.js";

export default {
  props: ['formData', 'temId', 'detailId'],
  data() {
    return {
      version: sessionStorage.getItem("maintainVersion"),
      categoryList2: [],
      parentList: [],
      statusList: [],
      detailForm: {},
      rules: {
        name: [
          { required: true, message: '请输入评分项名称', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '请输入SPM', trigger: 'blur' }
        ],
      },
      rulesList: localStorage.getItem('ms_roles'),
      identity: localStorage.getItem('ms_emplFlag'),
      statusView: ""
    }
  },
  created() {
    this.getParentCategoryList()
    let permission = JSON.parse(localStorage.getItem("ms_Permission"));
    if (this.identity == 'SUP') {   //判断是供应商
      this.statusView = 'S';
    } else {
      if (this.rulesList.indexOf('QSPI_AAA_OWNER') != -1 || this.rulesList.indexOf('QSPI_AAA_ADMIN') != -1) {
        this.statusView = 'All'
      } else {
        this.statusView = 'C'
      }
      // if(this.rulesList.indexOf('QSPI_AAA_CQS')!=-1&&this.rulesList.indexOf('QSPI_AAA_OWNER')!=-1){
      //   this.statusView = 'OC';
      // }else{
      //   for (let i = 0, len = permission.length; i < len; i++) {
      //     if (permission[i] == 'QSPI_AAA_OWNER') {
      //       this.statusView = 'O';
      //       return
      //     }else{
      //       this.statusView = 'C';
      //     }
      //   }
      // }
    }
  },
  mounted() {
    this.detailForm = this.formData
    this.detailForm.parentId = JSON.stringify(this.detailForm.parentId) == 'null' ? "" : JSON.stringify(this.detailForm.parentId)
    console.log("vvvvvvvvvvvv", this.detailForm)
  },
  watch: {
    formData: {
      handler(newV, oldV) {
        this.detailForm = newV
      },
      immediate: true
    }
  },
  methods: {
    onSave(formName) {
      if (!this.detailForm.name) {
        this.$message.error("请完善表单")
        return
      } else {
        apiService.updataOrAddTemInfoData(this.detailForm, this.temId).then((res) => {
          if (res.code == 200) {
            this.$message.success('保存成功')
            this.$emit('close')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     apiService.updataOrAddTemInfoData(this.detailForm,this.temId).then((res)=>{
      //         if(res.code==200){
      //           this.$message.success('保存成功')
      //           this.$emit('close')
      //         }else{
      //           this.$message.error(res.msg)
      //         }
      //     })
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    getParentCategoryList() {
      apiService.getParentCategoryList(this.temId).then((res) => {
        if (!this.detailForm.parentId) {
          res.resultData.forEach((v, i) => {
            if (v.code == this.temId) {
              res.resultData.splice(i, 1)
            }
          })
        }
        this.parentList = res.resultData
        console.log("循环的===", this.parentList)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>